import api from './client';
import type {
  AtualizarMetaCompraDimensaoRequest,
  CriarMetaCompraDimensaoRequest,
  DimensaoOpcao,
  DimensaoOpcoesResponse,
  DimensaoTipo,
  MetaCompraDimensao,
  MetaCompraDimensaoFiltros,
  MetaCompraDimensaoListResponse,
  MetaCompraDimensaoResponse,
} from '../types/metaCompraDimensao';

export const metaCompraDimensaoApi = {
  listar: async (filtros: MetaCompraDimensaoFiltros): Promise<MetaCompraDimensaoListResponse['data']> => {
    const params = new URLSearchParams();
    params.set('anoMes', filtros.anoMes);
    if (filtros.dimensao) params.set('dimensao', filtros.dimensao);
    if (filtros.busca) params.set('busca', filtros.busca);
    if (filtros.status) params.set('status', filtros.status);
    if (filtros.page) params.set('page', String(filtros.page));
    if (filtros.pageSize) params.set('pageSize', String(filtros.pageSize));
    if (filtros.ordenarPor) params.set('ordenarPor', filtros.ordenarPor);
    if (filtros.ordemDesc) params.set('ordemDesc', 'true');
    filtros.empresa?.forEach((e) => params.append('empresa', e));
    const resp = await api.get<MetaCompraDimensaoListResponse>(`/compras/metas/dimensao?${params.toString()}`);
    return resp.data.data;
  },

  obter: async (id: number): Promise<MetaCompraDimensao> => {
    const resp = await api.get<MetaCompraDimensaoResponse>(`/compras/metas/dimensao/${id}`);
    return resp.data.data;
  },

  criar: async (req: CriarMetaCompraDimensaoRequest): Promise<MetaCompraDimensao> => {
    const resp = await api.post<MetaCompraDimensaoResponse>('/compras/metas/dimensao', req);
    return resp.data.data;
  },

  atualizar: async (id: number, req: AtualizarMetaCompraDimensaoRequest): Promise<MetaCompraDimensao> => {
    const resp = await api.put<MetaCompraDimensaoResponse>(`/compras/metas/dimensao/${id}`, req);
    return resp.data.data;
  },

  excluir: async (id: number): Promise<void> => {
    await api.delete(`/compras/metas/dimensao/${id}`);
  },

  opcoes: async (dimensao: DimensaoTipo, q?: string, limit = 20): Promise<DimensaoOpcao[]> => {
    const params = new URLSearchParams();
    params.set('dimensao', dimensao);
    if (q) params.set('q', q);
    params.set('limit', String(limit));
    const resp = await api.get<DimensaoOpcoesResponse>(`/compras/metas/dimensao/opcoes?${params.toString()}`);
    return resp.data.data;
  },
};
